import React from 'react';
import ProfileContent from '../Components/Profile/ProfileContent';
import LoginLayout from '../Layouts/LoginLayout';

export default function Profile() {
  return (
    <LoginLayout>
        <ProfileContent />
    </LoginLayout>
  )
}
